import { CheckIcon } from '@heroicons/react/outline'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from 'src/hooks/auth'
import { api } from 'src/services/api'
import { documentFormatted } from 'src/utils/documentFormatted'
import type { BeneficiaryDataProps } from '.'

interface StateProps {
  endToEndId: string
  key: string
  selectedKey: string
  beneficiary: {
    number: string
    branch: string
    type: string
    participant: {
      name: string
      ispb: string
    }
    holder: {
      name: string
      document: string
      type: string
    }
  }
}

export interface PixProps {
  id: string
}

interface PixFavoritesProps {
  beneficiaryData: BeneficiaryDataProps
}

export const PixFavoretes = ({ beneficiaryData }: PixFavoritesProps) => {
  const navigate = useNavigate()
  const location = useLocation()
  const token = localStorage.getItem('@stricv2:token')

  const { account, user } = useAuth()

  const [open, setOpen] = useState(false)
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)

  const [maskedValue, setMaskedValue] = useState('')

  const [pixData, setPixData] = useState<PixProps>({} as PixProps)
  const [isFavorite, setIsFavorite] = useState({ isFavorite: false })

  const state = location.state as StateProps

  useEffect(() => {
    handleCheckIfKeyPixIsUsed(beneficiaryData?.key!)
  }, [])

  if (state === null) {
    navigate('/pix')
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleCancelButton = () => {
    navigate('/pix')
  }

  function parseAgency() {
    return state.beneficiary.branch
  }

  function onCloseModal() {
    setOpen(false)
    navigate('/extract')
  }

  function identificarTipoChavePix(key: string): string {
    const regexChaveAleatoria =
      /^[a-fA-F0-9]{8}-(?:[a-fA-F0-9]{4}-){3}[a-fA-F0-9]{12}$/
    const regexCNPJ = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$|^\d{14}$/
    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const regexCPF = /^\d{3}\.\d{3}\.\d{3}-\d{2}$|^\d{11}$/
    const regexCelular = /^\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/

    if (regexChaveAleatoria.test(key)) {
      return 'Chave Aleatória de Pix'
    } else if (regexCNPJ.test(key)) {
      return 'CNPJ'
    } else if (regexEmail.test(key)) {
      return 'E-mail'
    } else if (regexCPF.test(key)) {
      return 'CPF'
    } else if (regexCelular.test(key)) {
      return 'Celular'
    } else {
      return 'Formato não reconhecido'
    }
  }

  let selectedKey = identificarTipoChavePix(beneficiaryData.key as string)

  const handleAddContact = async (state: StateProps) => {
    let url = `/pix/favorites`
    let requestData = {
      // Renomeando para requestData
      contactName: beneficiaryData.name,
      //keyPix: documentFormatted(beneficiaryData?.key!),
      keyPix: beneficiaryData?.key!,

      keyType: selectedKey,
    }
    try {
      const response = await api.post<any[]>(url, requestData, {
        headers: { Authorization: 'Bearer ' + token },
      })
      setShowSuccessMessage(true)
    } catch (error) {
      console.error('Erro ao adicionar contato:', error)
    }
  }

  const handleCheckIfKeyPixIsUsed = async (keyPix: string): Promise<void> => {
    try {
      const response = await api.get(`/pix/favorites/check/${keyPix}`, {
        headers: { Authorization: 'Bearer ' + token },
      })
      setIsFavorite(response.data.isFavorite)
      console.log(isFavorite)
      console.log(response.data)
    } catch (error) {
      console.error(
        'Erro ao verificar se o keyPix está sendo utilizado:',
        error
      )
      throw error
    }
  }

  return (
    <>
      <div>
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
          <CheckIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Transferência Pix realizada
            <br />
            {maskedValue}
          </h3>
          <div className="mt-2 text-left">
            <p className="text-sm text-gray-500">
              <h2 className="mb-5 mt-5 text-lg">Dados do favorecido</h2>

              <div>
                <h2>Nome</h2>
                <h3>{beneficiaryData.name}</h3>
              </div>

              <div className="mt-5">
                <h2>Informações</h2>
                <h3>
                  {documentFormatted(beneficiaryData.payer_question ?? '')}
                </h3>
              </div>

              <div className="mt-5">
                <h2>Banco</h2>
                <h3>P2M</h3>
              </div>

              <div className="mt-5 flex">
                <div>
                  <h2>Agência</h2>
                  <h3>{beneficiaryData.agency}</h3>
                </div>

                <div className="ml-28">
                  <h2>Conta</h2>
                  <h3>{beneficiaryData.account}</h3>
                </div>
              </div>

              {/* <div className="mt-5">
								<h2>ID da transação</h2>
								<h3>{pixData?.id}</h3>
							</div> */}
            </p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6">
        <button
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          onClick={() => onCloseModal()}
        >
          Ir para o extrato
        </button>
        {isFavorite ? (
          <button
            type="button"
            className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 mt-2 py-2 text-base font-medium text-white bg-black cursor-not-allowed opacity-75 focus:outline-none sm:text-sm"
            disabled
          >
            Contato já favoritado com sucesso
          </button>
        ) : (
          <button
            type="button"
            className={`inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 mt-2 py-2 text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:text-sm ${
              showSuccessMessage
                ? 'bg-green-600 hover:bg-green-700 transition-colors duration-300 ease-in-out'
                : 'bg-green-500 hover:bg-green-600 transition-colors duration-300 ease-in-out'
            }`}
            onClick={() => {
              handleAddContact(state)
              setShowSuccessMessage(true)
            }}
          >
            {showSuccessMessage
              ? 'Salvo com sucesso'
              : 'Adicionar contato aos favoritos'}
          </button>
        )}

        {/* <button
					type="button"
					className="mt-5 inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2text-base font-medium  sm:text-sm text-black"
					onClick={() => onCloseModal()}
				>
					Comprovante disponível no extrato
				</button> */}
      </div>
    </>
  )
}
